import React from "react";
import "./Smedia.css";

const Smedia = () => {
  return (
    <>
      <div className="smedia">
        <div className="fb">
          <i className="fa-brands fa-facebook-f"></i>
          15k+ Likes
        </div>

        <div className="pint">
          <i className="fa-brands fa-pinterest"></i>
          8k+ Fans
        </div>

        <div className="twt">
          <i className="fa-brands fa-twitter"></i>
          12+ Followers
        </div>

        <div className="inst">
          <i className="fa-brands fa-instagram"></i>
          12+ Followers
        </div>

        <div className="yt">
          <i className="fa-brands fa-youtube"></i>
          16k+ Subscribers
        </div>
      </div>
    </>
  );
};

export default Smedia;
